<template>
  <div class="performance-add-edit-dialog">
    <el-dialog
      :title="
        readOnly
          ? '申报评估考核阶段详情'
          : isEdit
          ? '编辑申报评估考核阶段'
          : '添加申报评估考核阶段'
      "
      :visible.sync="dialogStatus"
      destroy-on-close
      :close-on-click-modal="false"
      width="620px"
      :before-close="dialogBeforeClose"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="performanceDom"
        label-width="180px"
      >
        <el-form-item label="申报评估考核阶段名称" prop="stageName">
          <el-input
            class="yioks-form-item"
            v-model.trim="formData.stageName"
            :disabled="readOnly"
            placeholder="请填写考核阶段名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="评估指标组" prop="groupUuid">
          <el-select
            class="yioks-form-item"
            v-model="formData.groupUuid"
            :disabled="readOnly"
            placeholder="请选择评估指标组"
          >
            <el-option
              v-for="item in performanceGroupList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="评估对象" prop="jixiaoType">
          <el-select
            class="yioks-form-item"
            v-model="formData.jixiaoType"
            placeholder="请选择评估对象"
            disabled
          >
            <el-option
              v-for="item in performanceGroupTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报名开始时间" prop="stageStartDate">
          <el-date-picker
            class="yioks-form-item"
            v-model="formData.stageStartDate"
            :value-format="'timestamp'"
            type="date"
            :disabled="readOnly"
            placeholder="请选择报名开始日期"
            :picker-options="StartPickerOptions"
          >
          </el-date-picker>
          <!-- :picker-options="pickerOptions" -->
        </el-form-item>

        <el-form-item label="报名结束时间" prop="stageEndDate">
          <el-date-picker
            class="yioks-form-item"
            v-model="formData.stageEndDate"
            :value-format="'timestamp'"
            type="date"
            :disabled="readOnly"
            placeholder="请选择报名结束日期"
            :picker-options="endPickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="当前是否开启评估">
          <el-switch
            v-model="formData.open"
            :disabled="readOnly"
            active-color="#4cd964"
          ></el-switch>
        </el-form-item>

        <el-form-item label="评估简介">
          <el-input
            class="yioks-form-item"
            v-model.trim="formData.description"
            placeholder="请填写评估简介"
            type="textarea"
            :disabled="readOnly"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="!readOnly" slot="footer" class="footer-btn-group">
        <el-button type="primary" @click="handleClose(true)">确 定</el-button>
        <el-button type="danger" @click="handleClose(false)">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postStageList,
  putStageList,
  getPerformanceListAll,
} from "@/api/performance";
import { requiredItem } from "@/assets/js/formRules";
import { performanceGroupTypeList } from "@/assets/js/yioksSelect";
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      requeired: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
      required: false,
    },

    defaultInfo: {
      type: Object,
      default: {
        stageName: "",
        groupUuid: "",
        description: "",
        stageStartDate: "",
        stageEndDate: "",
        open: false,
      },
    },

    readOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      formData: {
        stageName: "",
        groupUuid: "",
        jixiaoType: "",
        description: "",
        stageStartDate: "",
        stageEndDate: "",
        open: false,
      },
      formRules: {
        // requiredItem
        stageName: [requiredItem("审核阶段名称")],
        groupUuid: [requiredItem("指标组")],
        jixiaoType: [requiredItem("评估对象")],
        stageStartDate: [requiredItem("审核阶段开始时间")],
        stageEndDate: [requiredItem("审核阶段结束时间")],
      },
      performanceGroupList: [],
      performanceGroupTypeList,
    };
  },

  computed: {
    dialogStatus: {
      get() {
        return this.isOpen;
      },
      set(val) {
        this.$emit("closeGroupDialog", val, false);
      },
    },

    // 设置时间
    pickerOptionForStart() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      };
    },

    // 时间选择器
    endPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.formData.stageStartDate) {
            return time.getTime() < that.formData.stageStartDate;
          } else {
            return false;
          }
        },
      };
    },
    // 时间选择器
    StartPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          if (that.formData.stageEndDate) {
            return time.getTime() > that.formData.stageEndDate;
          } else {
            return false;
          }
        },
      };
    },
  },
  created() {
    this.loadperformanceListAll(); // 获取指标组可选项
    this.setDefaultData();
  },

  mounted() {},

  methods: {
    setDefaultData() {
      if (this.$store.getters.sysHostType === "youth") {
        this.$set(this.formData, "jixiaoType", "youth");
      } else if (this.$store.getters.sysHostType === "club") {
        this.$set(this.formData, "jixiaoType", "club");
      } else {
        this.$set(this.formData, "jixiaoType", "");
      }
      if (this.readOnly) {
        this.formData = Object.assign({}, this.formData, this.defaultInfo);
      }
      // if (!this.isEdit) return;
      // this.formData = Object.assign({}, this.formData, this.defaultInfo);
      if (this.isEdit) this.formData = Object.assign({}, this.formData, this.defaultInfo);
    },

    dialogBeforeClose() {
      this.formData = {
        stageName: "",
        groupUuid: "",
        description: "",
        stageStartDate: "",
        jixiaoType: "",
        stageEndDate: "",
        open: false,
      };
      this.$emit("closeGroupDialog", false, false);
    },

    handleClose(status) {
      if (status) {
        // 确认添加
        this.$refs.performanceDom.validate((valid) => {
          if (valid) {
            const postData = this.formData;
            let requestName = this.isEdit ? putStageList : postStageList;
            requestName(postData)
              .then((res) => {
                if (res.code) {
                  this.$message.error(res.msg);
                  return;
                }
                this.$emit("closeGroupDialog", false, status);
              })
              .catch((err) => {
                console.error("err", err);
                this.$message.error("操作失败，请稍后重试！");
              });
          } else {
            console.warn("校验不通过");
          }
        });
      } else {
        // 取消添加
        this.$emit("closeGroupDialog", false, status);
      }
    },

    // 获取指标组列表（不可分页）
    loadperformanceListAll() {
      const paramsData = {};
      getPerformanceListAll(paramsData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.performanceGroupList = res.map((item) => {
            const { groupName, uuid, ...rest } = item;
            return {
              label: groupName,
              value: uuid,
              metaData: rest,
            };
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
</style>
